var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { CampaignReview } from './campaign-review';
import { useSession } from '../../../../../infra/session';
import { useNavigate, useRouteParams } from '../../../../../infra/routing';
import { goToPreviousStep } from './go-to-previous-step';
import { goToNextStep } from './go-to-next-step';
import { endpoints } from '../../../network';
import { useApiMutation } from '../../../../../infra/api';
import { duplicateCampaign } from './duplicate-campaign';
import { useSelectedAudience, useCampaignActions, useCampaignDetails, useDeliveryChannel } from '../../hooks';
import { EngageTracker, ENGAGE_REVIEW_PREVIEW_CHANNEL_SWITCHED } from '../../../tracking';
export var CampaignReviewContainer = function () {
    var store = useStore();
    var navigate = useNavigate();
    var session = useSession().data;
    var campaignId = useRouteParams().campaignId;
    var _a = useCampaignDetails(campaignId, true), campaign = _a.campaign, campaignContents = _a.campaignContents, isLoading = _a.isLoading;
    var duplicateCampaignMutation = useCampaignActions().duplicateCampaign;
    var _b = useSelectedAudience(), _c = _b.audiences, audiences = _c === void 0 ? [] : _c, isAudiencesLoading = _b.isLoading;
    var _d = useDeliveryChannel(), availableDeliveryChannelsOptions = _d.availableDeliveryChannelsOptions, selectedDeliveryChannel = _d.selectedDeliveryChannel, setSelectedDeliveryChannel = _d.setSelectedDeliveryChannel;
    var shouldShowPromoPreview = (campaign === null || campaign === void 0 ? void 0 : campaign.type) === 'promotion' && !!campaign.promo;
    var chargeCampaignMutation = useApiMutation({
        endpoint: endpoints.chargeCampaignMutation,
    });
    var handlePreviousStep = function () {
        goToPreviousStep({ store: store, navigate: navigate, session: session, campaignId: campaignId });
    };
    var handleNextStep = function () {
        goToNextStep({ store: store, navigate: navigate, session: session, campaignId: campaignId, chargeCampaignMutation: chargeCampaignMutation });
    };
    var handleDuplicateClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, duplicateCampaign({
                        campaign: campaign,
                        navigate: navigate,
                        session: session,
                        store: store,
                        duplicateCampaignMutation: duplicateCampaignMutation,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSelectDeliveryChannel = function (deliveryChannel) {
        var previousChannel = selectedDeliveryChannel;
        setSelectedDeliveryChannel(deliveryChannel);
        EngageTracker.getInstance().track(ENGAGE_REVIEW_PREVIEW_CHANNEL_SWITCHED, {
            fromChannel: previousChannel,
            toChannel: deliveryChannel,
            step: 'review',
            campaignId: campaignId,
        });
    };
    if (!campaign) {
        return null;
    }
    return (_jsx(CampaignReview, { title: "Review before sending", campaign: campaign, audiences: audiences, promo: campaign === null || campaign === void 0 ? void 0 : campaign.promo, shouldShowPromoPreview: shouldShowPromoPreview, isAudiencesLoading: isAudiencesLoading, shouldShowPreviousStepButton: !isAudiencesLoading, shouldShowNextStepButton: !isAudiencesLoading, showActionButtons: false, campaignContents: campaignContents, displayDeliveryChannelSwitch: availableDeliveryChannelsOptions.length > 1, isCampaignContentsLoading: isLoading, availableDeliveryChannelsOptions: availableDeliveryChannelsOptions, selectedDeliveryChannel: selectedDeliveryChannel, onSelectDeliveryChannel: handleSelectDeliveryChannel, onPreviousStep: handlePreviousStep, onNextStep: handleNextStep, onDuplicateClick: handleDuplicateClick }));
};
